import React, { useEffect, useState } from "react";
import { Wrapper } from "../../components/Wrapper";
import { PageTitle } from "../../components/PageTitle";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import { toast } from "react-toastify";
import { Preload } from "../../components/Preload";
import { GET_FILTER_PROPS } from "../../graphql/Queries/ObjectQuery";
import { CHANGE_SORT_FILTER_PROPS } from "../../graphql/Mutations/ObjectTypeMutation";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import i18next from "i18next";

export const FilterSort = ({ id = null }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const [changeSortStep] = useMutation(CHANGE_SORT_FILTER_PROPS);
  const { load, error, data } = useQuery(GET_FILTER_PROPS, {
    variables: {
      id: Number(searchParams.get("id")),
      lang: i18next.language,
    },
    fetchPolicy: "no-cache",
  });
  if (error) {
    toast.error(error.message);
  }
  const languages = [
    {
      url: "ru",
      label: t("Ру"),
    },
    {
      url: "az",
      label: t("Az"),
    },
    {
      url: "en",
      label: t("En"),
    },
  ];
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (data) {
      setItems(data.property);
    }
  }, [data]);

  const SortableItem = SortableElement(({ item }) => {
    return (
      <div className="dd-list" style={{ marginBottom: 10 }}>
        <div className="dd-item">
          <div
            className="dd-handle"
            style={{ backgroundColor: "rgb(196, 198, 198)" }}
          >
            <div>
              <span>{item.nameString}</span>
            </div>
          </div>
        </div>
      </div>
    );
  });

  const SortableList = SortableContainer(({ items }) => {
    return (
      <di>
        {items.map((item, index) => {
          return (
            <SortableItem key={`item-${index}`} index={index} item={item} />
          );
        })}
      </di>
    );
  });

  if (!data) {
    return <Preload />;
  }

  return (
    <Wrapper>
      <PageTitle
        title={"Редактировать расположение"}
        breadcrumbs={[
          {
            slug: "/type-objects",
            name: "Типы объектов",
          },
        ]}
      />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <Row>
                <Col md={12}>
                  <SortableList
                    items={items}
                    onSortEnd={({
                      oldIndex,
                      newIndex,
                      collection,
                      isKeySorting,
                    }) => {
                      const _steps = [...items];
                      const el = _steps[oldIndex];
                      _steps.splice(oldIndex, 1);
                      _steps.splice(newIndex, 0, el);
                      setItems(_steps);
                      const arr = [];
                      _steps.map((item, index) => {
                        arr.push({ id: item.id, sort: index + 1 });
                      });
                      changeSortStep({
                        variables: {
                          arr: JSON.stringify(arr),
                          object_type_id: Number(searchParams.get("id")),
                        },
                      })
                        .then((response) => {
                          console.log("[Log]", response.data);
                        })
                        .catch((error) => {
                          console.log("[Err]", error);
                        });
                    }}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
